import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { LockIcon } from 'lucide-react';
const PASSWORD = 'Hallo';
const STORAGE_KEY = 'steinkarten-unlocked';
interface PasswordGateProps {
  children: React.ReactNode;
}
export function PasswordGate({
  children
}: PasswordGateProps) {
  const [unlocked, setUnlocked] = useState<boolean>(() => sessionStorage.getItem(STORAGE_KEY) === 'true');
  const [value, setValue] = useState('');
  const [error, setError] = useState(false);
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (value === PASSWORD) {
      sessionStorage.setItem(STORAGE_KEY, 'true');
      setUnlocked(true);
      setError(false);
    } else {
      setError(true);
      setValue('');
    }
  };
  if (unlocked) return <>{children}</>;
  return <div className="flex min-h-full w-full items-center justify-center bg-slate-900 px-6" data-id="element-18">
      <motion.form onSubmit={submit} initial={{
      opacity: 0,
      y: 12,
      scale: 0.97
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} className="w-full max-w-xs rounded-2xl bg-white p-6 shadow-2xl" data-id="element-19">
        <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-slate-900" data-id="element-20">
          <LockIcon className="h-6 w-6 text-white" data-id="element-21" />
        </div>
        <h1 className="text-xl font-extrabold tracking-tight text-slate-800" data-id="element-22">
          Geschützter Bereich
        </h1>
        <p className="mt-1 text-sm text-slate-500" data-id="element-23">
          Bitte gib das Passwort ein, um fortzufahren.
        </p>

        <motion.div animate={error ? {
        x: [0, -8, 8, -6, 6, 0]
      } : {
        x: 0
      }} transition={{
        duration: 0.4
      }} className="mt-5" data-id="element-24">
          <label htmlFor="pw" className="sr-only" data-id="element-25">
            Passwort
          </label>
          <input id="pw" type="password" autoFocus value={value} onChange={e => {
          setValue(e.target.value);
          setError(false);
        }} placeholder="Passwort" className={`w-full rounded-xl border px-4 py-3 text-base outline-none transition focus:ring-2 ${error ? 'border-rose-400 focus:ring-rose-300' : 'border-slate-300 focus:ring-slate-400'}`} aria-invalid={error} data-id="element-26" />
        </motion.div>

        {error && <p className="mt-2 text-sm font-medium text-rose-500" data-id="element-27">
            Falsches Passwort.
          </p>}

        <motion.button type="submit" whileTap={{
        scale: 0.97
      }} className="mt-5 w-full rounded-xl bg-slate-900 px-5 py-3.5 text-base font-semibold text-white shadow-lg active:bg-slate-800" data-id="element-28">
          Entsperren
        </motion.button>
      </motion.form>
    </div>;
}